import { Component, OnInit } from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";
import { Chart } from "angular-highcharts";
import { EventService } from "src/app/services/event.service";
import { PdiTableData } from "../pdi.component";
import { chartConfigs } from "../../epack/epack.component";

@Component({
  selector: "app-pdi-lite",
  templateUrl: "./pdi-lite.component.html",
  styleUrls: ["./pdi-lite.component.css"],
})
export class PdiLiteComponent implements OnInit {
  constructor(private eventService: EventService) {}

  currentDate = new Date();
  selectedYear: number = this.currentDate.getFullYear();
  selectedMonth: number = this.currentDate.getMonth() + 1;
  yearlyTestsChart: Chart;
  monthlyTestsChart: Chart;
  yearlyTestsChartData: {
    [year: number]: number[];
  };
  monthlyTestsChartData: {
    passing: { [month: number]: number[] };
    failing: { [month: number]: number[] };
  };

  defaultChartOptions: Highcharts.Options = {
    title: {
      text: "",
    },
    credits: {
      enabled: false,
    },
    exporting: {
      enabled: false,
    },
    legend: {
      enabled: true,
    },
    yAxis: {
      title: {
        text: "",
      },
    },
  };
  graphHeight: number = 300;
  monthlyTestYears: number[] = [2025];

  dailyTestMonths = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  tableDatasource: MatTableDataSource<PdiTableData> = new MatTableDataSource(
    []
  );

  packType: "TG" | "PL" = "TG";

  ngOnInit(): void {
    this.getyearlyTestsData();
  }

  getMonthlyTestsData(year: number) {
    this.eventService.getpdiDashboardMonthlyTestsData(year).subscribe({
      next: (res) => {
        if (res.body.success) {
          this.monthlyTestsChartData = {
            failing: res.body.data.failing,
            passing: res.body.data.passing,
          };

          this.plotMonthlyTestsGraph(
            this.monthlyTestsChartData.passing[this.selectedMonth],
            this.monthlyTestsChartData.failing[this.selectedMonth]
          );
        }
      },
      error: (err) => {
        console.log(err);
      },
    });
  }

  getyearlyTestsData() {
    this.eventService.getpdiDashboardYearlyTestsData().subscribe({
      next: (res) => {
        if (res.body.success) {
          this.yearlyTestsChartData = res.body.data;
          this.plotYearlyTestsGraph(
            this.yearlyTestsChartData[this.selectedYear]
          );

          this.getMonthlyTestsData(this.selectedYear);
        }
      },
      error: (err) => {
        console.log(err);
      },
    });
  }

  onYearchange() {
    // reset months selection when year changes
    this.selectedMonth = this.currentDate.getMonth() + 1;

    const currentYearData =
      this.yearlyTestsChartData[this.selectedYear] ?? Array(12).fill(0);

    this.plotYearlyTestsGraph(currentYearData);
    this.getDashboardMonthlyTestsData(this.selectedYear);
  }

  onMonthChange() {
    this.plotMonthlyTestsGraph(
      this.monthlyTestsChartData.passing[this.selectedMonth],
      this.monthlyTestsChartData.failing[this.selectedMonth]
    );
  }

  getDashboardMonthlyTestsData(year: number) {
    this.eventService.getIpqcDashboardMonthlyTestsData(year).subscribe({
      next: (response: {
        success: boolean;
        data: {
          passing: { [month: number]: number[] };
          failing: { [month: number]: number[] };
        };
      }) => {
        if (response.success) {
          this.monthlyTestsChartData = {
            failing: response.data.failing,
            passing: response.data.passing,
          };

          this.plotMonthlyTestsGraph(
            this.monthlyTestsChartData.passing[this.selectedMonth],
            this.monthlyTestsChartData.failing[this.selectedMonth]
          );
        }
      },
    });
  }

  plotYearlyTestsGraph(graphData: number[]) {
    this.yearlyTestsChart = new Chart({
      ...this.defaultChartOptions,
      legend: {
        enabled: false,
      },
      chart: {
        height: this.graphHeight,
      },
      xAxis: { categories: chartConfigs.axisData.monthlyTests },
      tooltip: {
        headerFormat: '<h1 style=""><b>{point.key}:</b> {point.y}</h1></br>',
        pointFormat: "",
        footerFormat: "",
      },
      series: [
        {
          type: "column",
          data: graphData,
          color: chartConfigs.colors.total,
        },
      ],
    });
  }

  plotMonthlyTestsGraph(passingData: number[], failingData: number[]) {
    const daysInMonth = new Date(
      this.selectedYear,
      this.selectedMonth,
      0
    ).getDate();
    const categories = [];
    const testMonth = this.dailyTestMonths[this.selectedMonth - 1];

    for (let i = 0; i < daysInMonth; i++) {
      categories[i] = i + 1;
    }

    this.monthlyTestsChart = new Chart({
      ...this.defaultChartOptions,
      chart: {
        height: this.graphHeight,
      },
      xAxis: {
        categories: categories,
      },
      tooltip: {
        headerFormat: `<h2><b>${testMonth} {point.key} </b></h2></br>`,
        shared: true,
      },
      series: [
        {
          type: "spline",
          name: "Failed Tests",
          color: chartConfigs.colors.pending,
          data: failingData,
        },
        {
          type: "spline",
          name: "Passed Tests",
          color: chartConfigs.colors.completed,
          data: passingData,
        },
      ],
    });
  }
}
